import isLocal from './isLocal';
import {
  // TODO: Move these constants to this file.
  FRESHBOOKS_REDIRECT_PATHNAME,
  QUICKBOOKS_REDIRECT_PATHNAME,
  STRIPE_REDIRECT_PATHNAME,
} from './constants/Constants';

const typeToPathName = {
  freshbooks: FRESHBOOKS_REDIRECT_PATHNAME,
  quickbooks: QUICKBOOKS_REDIRECT_PATHNAME,
  stripe: STRIPE_REDIRECT_PATHNAME,
  default: '/',
};

type RedirectType = keyof typeof typeToPathName;

// TODO: Switch the order of these parameters so we can make `type` optional.
export default function createRedirectURI(type: RedirectType, host: string) {
  let pathname = typeToPathName[type];
  let protocol = isLocal(host) ? 'http://' : 'https://';
  let redirectUrl = isLocal(host) ? pathname : `${protocol}${host}${pathname}`;
  return redirectUrl;
}

export function createRedirectURIStripe(type: RedirectType, host: string) {
  let pathname = typeToPathName[type];
  let protocol = isLocal(host) ? 'http://' : 'https://';
  return `${protocol}${host}${pathname}`;
}
